module.exports = __webpack_public_path__ + "assets/img/decc-fr.svg";